

























































































































































































































































































import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import * as am from "@/store/modules/ApplicationModule/mutations";
import * as ad from "@/store/modules/DevicesModule/actions";
import * as m from "@/store/modules/DevicesModule/mutations";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

// Vue components
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import TagAssociationCard from "@/views/App/ServiceAndUpdates/UpdatesManagement/BulkUpdatesWizard/TagAssociationCard.vue";
import VFaIcon from "../VFaIcon.vue";
import CreateNewFolderDialog from "./CreateNewFolderDialog.vue";
import DeviceDetailsTooltipCard from "./DeviceDetailsTooltipCard.vue";
import EditFolderDataDialog from "./EditFolderDataDialog.vue";
import MoveDeviceDialog from "./MoveDeviceDialog.vue";
import MoveFolderDialog from "./MoveFolderDialog.vue";
import SearchCard from "./SearchCard.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetDataFlowOrganizationsConvertersCommand } from "@/model/communication/dataFlow/GetDataFlowOrganizationsConvertersCommand";
import { GetDataFlowOrganizationsConvertersResData } from "@/model/communication/dataFlow/GetDataFlowOrganizationsConvertersResData";
import { CreateNewFolderCommand } from "@/model/communication/foldersManagement/CreateNewFolderCommand";
import { DeleteFolderCommand } from "@/model/communication/foldersManagement/DeleteFolderCommand";
import { RenameFolderCommand } from "@/model/communication/foldersManagement/RenameFolderCommand";
import { GetOrganizationsCommand } from "@/model/communication/organizations/GetOrganizationsCommand";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { FolderDeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { Organization } from "@/model/data/organizations/Organization";
import { DEVICE_TREE_CONSTANTS as K } from "@/utility/Constants";
import { findParentNodesFromMultipleFolderIds } from "@/utility/TreeviewUtility";
import _ from "lodash";

export default Vue.extend({
    components: {
        MoveDeviceDialog,
        DeviceDetailsTooltipCard,
        SearchCard,
        CreateNewFolderDialog,
        VFaIcon,
        ConfirmationDialog,
        TagAssociationCard,
        MoveFolderDialog,
        EditFolderDataDialog,
    },
    data() {
        return {
            // import
            K,
            DeviceTreeNodeTypeEnum,

            // component management
            cardLoading: false,
            isSearchMode: false,
            showMoveDeviceDialog: false,
            showDeviceDetailsTooltipCard: false,
            showCreateNewFolderDialog: false,
            showEditFolderDataDialog: false,
            showBulkEditTagsDialog: false,
            showMoveFolderDialog: false,

            // data
            openedTreeviewNodes: [],
            localSelection: [],
            preselectedFolderIdFilterInSearchCard: null,
            deviceIdForDetailsTooltipCard: null,
            singleDeviceToMode: null,
            installationNamesToMove: null,
            installationNamesBulkEditTags: null,
            createFolderIn: null,
            editFolderData: null,
            availableFolderRoles: [],

            // folder management
            isEditFolderNameMode: false,
            editFolderNameId: -1,
            tempFolderName: "",
            isDeleteFolderMode: false,
            deleteFolderId: -1,
            folderToMove: null,
            serverOrganizations: [],
        };
    },
    props: {
        title: String,
        value: {},
        editable: {
            type: Boolean,
            default: true,
        },
        returnObject: {
            type: Boolean,
            default: true,
        },
        showSelectedCount: {
            type: Boolean,
            default: false,
        },
        selectionType: {
            type: String,
            default: "leaf",
        },
        preselectRoot: {
            type: Boolean,
            default: false,
        },
        organizations: { type: Array as () => Array<Organization> },
    },
    computed: {
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
            openDeviceTreeToFolderIdEvent: (state: RootState): number => state.application.openDeviceTreeToFolderIdEvent,
        }),

        ...mapGetters(["authUserHasPrivilege", "rootFoldersIds"]),

        rootFoldersIdsComp() {
            return this.rootFoldersIds;
        },

        treeViewContent() {
            return this.deviceTree;
        },

        devicesManagementPrivilege() {
            return this.authUserHasPrivilege(ClientPrivileges.DevicesManagement) && this.editable;
        },

        dataFlowDeviceDetailsManagementPrivilege() {
            return this.authUserHasPrivilege(ClientPrivileges.DataFlowDeviceDetailsManagement);
        },

        hoverColor() {
            if ((this.$store.state as RootState).authMod.currentUser.userConfig != null)
                return (this.$store.state as RootState).authMod.currentUser.userConfig.theme != "dark" ? "grey lighten-4" : "grey darken-2";
            else return "";
        },
    },
    watch: {
        localSelection(newValue: Array<any>) {
            this.$emit("input", newValue && newValue.length ? newValue : []);
        },

        openDeviceTreeToFolderIdEvent(newValue) {
            if (newValue != -1) this.setOpenedTreeviewNodes([newValue]);
            this[am.OPEN_DEVICE_TREE_TO_FOLDER_ID](-1);
        },

        isSearchMode(newValue) {
            if (!newValue) this.preselectedFolderIdFilterInSearchCard = null;
        },

        showDeviceDetailsTooltipCard(newValue) {
            if (!newValue) this.deviceIdForDetailsTooltipCard = null;
        },

        showMoveDeviceDialog(newValue) {
            if (!newValue) this.installationNamesToMove = null;
        },

        showBulkEditTagsDialog(newValue) {
            if (!newValue) this.installationNamesBulkEditTags = null;
        },

        showCreateNewFolderDialog(newValue) {
            if (!newValue) this.createFolderIn = null;
        },

        showEditFolderDataDialog(newValue) {
            if (!newValue) {
                this.editFolderData = null;
            }
        },
    },
    methods: {
        ...mapActions([ad.FETCH_ALL_DEVICE_TREE]),
        ...mapMutations([m.SET_DEVICE_TREE_CONTENT, am.OPEN_DEVICE_TREE_TO_FOLDER_ID]),

        moveDevices(installationNamesToMove) {
            if (installationNamesToMove == null) this.installationNamesToMove = this.localSelection.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
            else this.installationNamesToMove = installationNamesToMove;
            this.showMoveDeviceDialog = true;
        },

        moveFolder(folderToMove) {
            if (folderToMove != null || folderToMove != undefined) {
                this.folderToMove = folderToMove;
                this.showMoveFolderDialog = true;
            }
        },

        clearLocalSelection() {
            this.localSelection = [];
            if (this.$refs.searchCard) this.$refs.searchCard.clearLocalSelection();
        },

        searchInSpecificFolder(folderId) {
            this.preselectedFolderIdFilterInSearchCard = +folderId;
            this.isSearchMode = true;
        },

        setShowDeviceDetailsTooltipCard(deviceId) {
            this.deviceIdForDetailsTooltipCard = deviceId;
            this.showDeviceDetailsTooltipCard = true;
        },

        // Bulk edit tags
        bulkEditTags() {
            this.installationNamesBulkEditTags = this.localSelection.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
            this.showBulkEditTagsDialog = true;
        },

        // FOLDERS MANAGEMENT
        // create
        openCreateFolderDialog(createFolderIn) {
            this.createFolderIn = createFolderIn;
            this.showCreateNewFolderDialog = true;
        },

        async createFolderInSendRequest(payload) {
            try {
                this.cardLoading = true;
                let res = await new CreateNewFolderCommand(payload.createInId, payload.newFolderName, payload.createBranch, payload.branchGln, payload.branchLocation).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) this.reloadAllDeviceTree([payload.createInId]);
                this.cardLoading = false;
            } catch (error) {
                console.error("error in createFolderIn, exc: ", error);
                this.cardLoading = false;
            }
        },

        // edit name
        enterInEditFolderNameMode(folderId: number, serverFolderName: string) {
            this.isEditFolderNameMode = true;
            this.editFolderNameId = folderId;
            this.tempFolderName = serverFolderName;
        },

        // edit folder data
        enterInEditFolderDataMode(folder: FolderDeviceTreeNode) {
            this.getOrganizationsConverter();
            this.editFolderData = folder;
            this.showEditFolderDataDialog = true;
        },

        exitFromEditFolderNameMode() {
            this.isEditFolderNameMode = false;
            this.editFolderNameId = -1;
            this.tempFolderName = "";
        },

        async editFolderNameSendRequest(folderId: number, newFolderName: string) {
            try {
                this.cardLoading = true;
                let res = await new RenameFolderCommand(folderId, newFolderName).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) this.reloadAllDeviceTree([folderId]);
                this.exitFromEditFolderNameMode();
                this.cardLoading = false;
            } catch (error) {
                console.error("error in editFolderNameSendRequest, exc: ", error);
                this.cardLoading = false;
            }
        },

        // delete
        async enterInDeleteFolderMode(folderId: number) {
            await this.getOrganizations();
            this.isDeleteFolderMode = true;
            this.deleteFolderId = folderId;
        },

        async getOrganizations() {
            try {
                const res = await new GetOrganizationsCommand().execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) this.serverOrganizations = _.cloneDeep(res.organizations);
            } catch (e) {
                console.error("Something went wrong during GetOrganizationsCommand execution: ", e);
            }
        },

        async getOrganizationsConverter() {
            try {
                let response: GetDataFlowOrganizationsConvertersResData = await new GetDataFlowOrganizationsConvertersCommand(true).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString == "Success") {
                    this.availableFolderRoles = response.folderRoles;
                } else console.error(this.$t("dataFlow.errorGetConverter", { message: response.message }));
            } catch (e) {
                console.error("Something went wrong sending PostDataFlowDeviceDetailsCommand request ", e);
            }
        },

        exitFromDeleteFolderMode() {
            this.isDeleteFolderMode = false;
            this.serverOrganizations = [];
            this.deleteFolderId = -1;
        },

        async deleteFolder() {
            try {
                this.cardLoading = true;
                let res = await new DeleteFolderCommand(this.deleteFolderId).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) this.reloadAllDeviceTree(this.rootFoldersIds);
                this.exitFromDeleteFolderMode();
                this.cardLoading = false;
            } catch (error) {
                console.error("error in deleteFolder, exc: ", error);
                this.cardLoading = false;
            }
            this.cardLoading = false;
        },

        async reloadAllDeviceTree(openNodesToFolderIds) {
            console.log("reloadAllDeviceTree and open it to these ids: ", openNodesToFolderIds);
            this[m.SET_DEVICE_TREE_CONTENT]({ node: null, content: [] }); // deviceTree = []
            await this[ad.FETCH_ALL_DEVICE_TREE](); // ricarico tutto l'albero di nuovo
            if (Array.isArray(openNodesToFolderIds) && openNodesToFolderIds.length > 0) this.setOpenedTreeviewNodes(openNodesToFolderIds);
        },

        setOpenedTreeviewNodes(openNodesToFolderIds) {
            this.openedTreeviewNodes = findParentNodesFromMultipleFolderIds(this.deviceTree, openNodesToFolderIds);
        },
    },
    async mounted() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            let req = JSON.parse(atob(this.$route.query.reqData));
            if (!req.installationNames || !req.installationNames.length) {
                this.localSelection = this.value;
            } else {
                let queue = [this.deviceTree[0]];
                let founded = 0;
                while (queue.length && founded < req.installationNames.length) {
                    let node = queue.pop();
                    if (req.installationNames.includes(node.name)) {
                        this.localSelection.push(node);
                        founded++;
                    }
                    if (node.children && node.children.length) queue.push(...node.children);
                }
            }
        } else this.localSelection = this.value;
        this.setOpenedTreeviewNodes(this.rootFoldersIdsComp);
        if (this.preselectRoot) this.localSelection.push(this.treeViewContent[0]);
    },
});
